<template>
    <div>
        <b-row
            :class="[!element.selected ? 'font-italic' : '']"
            class="w-100 pt-3 ml-0"
            align-v="start"
            align-h="between"
        >
            <b-col class="pl-0">
                <b-form-checkbox
                    v-model="element.selected"
                    class="align-items-start"
                    plain
                    @change="stateChanged"
                >
                    <span>{{ due_text }}: </span>
                    <span v-if="element.medications">
                        {{
                            _.map(
                                element.medications,
                                medication => medication.name
                            ).join(",")
                        }}
                    </span>
                    <span v-if="element.otherTasks">
                        {{
                            _.map(
                                element.otherTasks,
                                task => task.taskType
                            ).join(",")
                        }}
                    </span>
                    <span v-if="element.vitals">
                        {{
                            _.map(element.vitals, vital => vital.name).join(
                                ", "
                            )
                        }}
                    </span></b-form-checkbox
                >
            </b-col>
            <b-col v-if="element.medications" class="p-0" cols="5">
                <b-row no-gutters style="margin: -0.25rem 0;">
                    <b-form-input
                        type="number"
                        class="col-4"
                        @blur="quantityBlur"
                        :disabled="!element.selected"
                        v-model="element.medications[0].quantity"
                    ></b-form-input>
                    <span class="py-1 col-5">
                        {{ element.medications[0].uom.value }}
                    </span>
                    <dosage
                        v-if="weight"
                        :item-id="element.medications[0].item_id"
                        :weight-data="{
                            weight: weight.value,
                            uom: weight.uom_id
                        }"
                        :data="{ id: element.id }"
                        target="quantity"
                        parent-id="treatementStart"
                        class="btn-sm ml-auto"
                    />
                </b-row>
            </b-col>
        </b-row>
        <hr class="mb-0" />
    </div>
</template>
<script>
import Dosage from "@/module/commons/dosage.vue";
import { DateTime } from "luxon";
import { get, find, some } from "lodash";

export default {
    name: "ActivitiesTemplateItems",
    components: {
        Dosage
    },
    props: {
        element: {
            type: Object,
            default() {
                return { selected: true };
            }
        },
        patientId: {
            type: String,
            required: true,
            default: null
        }
    },
    data() {
        return {};
    },
    computed: {
        due_text() {
            return DateTime.fromSeconds(this.element.time)
                .setZone(this._timeZone)
                .toFormat("hh:mm a");
        },
        weight() {
            const vitals = get(
                this.$store.state.patients,
                this.patientId + ".vitals"
            );
            let weight = find(vitals, { type: 4 });

            return vitals && weight ? weight : { value: null, uom_id: null };
        }
    },
    watch: {
        "element.selected"(value) {
            this.$emit("selected", value);
        }
    },
    mounted() {
        this.element.selected = true;
    },
    methods: {
        stateChanged(event) {
            if (some(this.element.medications)) {
                if (event) {
                    if (this.element.originalQuantity) {
                        this.element.medications[0].quantity = this.element.originalQuantity;
                    }
                } else {
                    this.element.originalQuantity = this.element.medications[0].quantity;
                    this.element.medications[0].quantity = 0;
                }
            }
        },
        quantityBlur(event) {
            if (event.target.value === "") {
                this.element.medications[0].quantity = "0";
            }
        }
    }
};
</script>
